import { render } from "./ProfileHelperNode.vue?vue&type=template&id=3836b0c0&ts=true&lang=html"
import script from "./ProfileHelperNode.vue?vue&type=script&lang=ts"
export * from "./ProfileHelperNode.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__